// extracted by mini-css-extract-plugin
module.exports = {"checkoutFooter":"az_pn","footerBox":"az_qn","copyright":"az_rn","digicert":"az_sn"};